export enum Key {
    ARROW_DOWN = 'ArrowDown',
    ARROW_UP = 'ArrowUp',
    ENTER = 'Enter',
    SPACE = 'Space',
    TAB = 'Tab',
    ESCAPE = 'Escape'
}
